import {validateField, clearFields, setFieldOptions, setCheckBoxValue} from './helpers/form'
import {
  SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VACANCY_CRITERIA_TRANSLATOR_FIELD,
  CLEAR_VACANCY_CRITERIA_TRANSLATOR_FIELDS,
  SET_VACANCY_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/vacancy-page'

export function vacancyCriteriaTranslator (
  state = {
    valid: false,
    fields: [
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Additional language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AgeFrom',
        value: '',
        errors: [],
        rules: {
          title: 'Age from'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'AgeTo',
        value: '',
        errors: [],
        rules: {
          title: 'Age to'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'Preferred  city'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'CountryofLiving',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Country of residence'
        },
        placeholder: 'Any country',
        options: []
      },
      {
        name: 'Region',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Region'
        },
        placeholder: 'Any region',
        options: []
      },
      {
        name: 'Ethnicity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Ethnicity'
        },
        placeholder: 'Any ethnicity',
        options: []
      },
      {
        name: 'Identity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Identity'
        },
        placeholder: 'Any identity',
        options: []
      },
      {
          name: 'DoNotUse',
          value: '',
          type: 'checkbox',
          errors: [],
          rules: {
            title: 'Do not use'
          },
          options: []
      },
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'SkillVendorStatus',
        value: '',
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Inactive talent'
        },
        options: []
      },
      {
        name: 'TranslatorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'TranslatorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'TranslatorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'TranslatorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'TranslatorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'TranslatorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'TranslatorSubtitlesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Subtitles'
        }
      },
      {
        name: 'TranslatorDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'TranslatorVoiceOverExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O'
        }
      },
      {
        name: 'TranslatorGamingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'TranslatorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'TranslatorHOHSDHCCExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Access service subtitling'
        }
      },
      {
        name: 'TranslatorNumberOfTranslations',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Number of translations'
        },
        placeholder: 'Any number',
        options: []
      },
      {
        name: 'TranslatorUniversityDegree',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'University degree'
        },
        placeholder: 'Any degree',
        options: []
      },
      {
        name: 'TranslatorStudios',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'Translator'
        },
        placeholder: 'Any studio'
      },
      {
        name: 'TranslatorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'Translator'
        },
        placeholder: 'Any client'
      }
    ]
  },
  action
) {
  switch (action.type) {
    case SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'RemoteRecordingCapability', action.remoteRecordingCapabilityList);
      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VACANCY_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VACANCY_CRITERIA_TRANSLATOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CRITERIA_TRANSLATOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
